/**
 * TKP-241 p.4 — taslağa yazılan işlemde tek bildirim: kesici "Değişiklikler taslağa kaydedildi" bilgisini gösterir, ekranın hemen
 * ardından verdiği "İşlem başarıyla tamamlandı" türü başarı bildirimi düşer (bildirim katmanında, her ekranı ayrı ayrı değiştirmeden).
 * Toplu işlemde (TKP-237 batch) ara bildirim yok — işlemin kendi özeti tek bildirimdir ve düşürülmez.
 */
export const DRAFT_SUCCESS_WINDOW = 3000;
let lastDraftAt = 0;

export const noteDraft = (now = Date.now()) => {
  lastDraftAt = now;
};
export const resetDraftNotice = () => {
  lastDraftAt = 0;
};
/** Bildirim süzgeci: taslak bildiriminden kısa süre sonra gelen başarı bildirimi `false` (gösterilmez); diğerleri olduğu gibi. */
export const suppressAfterDraft = (toast, now = Date.now()) => (toast && toast.type === "success" && lastDraftAt && now - lastDraftAt < DRAFT_SUCCESS_WINDOW ? false : toast);
